// src/app/shared/dialog/dialog.component.ts

import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  standalone: false
})
export class DialogComponent implements OnInit {
  @Output() confirmAction: EventEmitter<boolean> = new EventEmitter<boolean>();
  data: any;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {}

  ngOnInit(): void {
    this.data = this.config.data;
    console.log('dialogdata', this.data);
  }

  ngOnDestroy() {
    if (this.ref) {
      this.ref.close();
    }
  }
  onConfirm() {
    this.confirmAction.emit(true); // Emit confirmation signal
    this.ref.close(true); // Close the dialog
  }

  onCancel() {
    this.ref.close(false); // Close the dialog without confirming
  }
  onNoClick(): void {
    this.ref.close('close');
  }
  OnYesClick(): void {
    this.ref.close(true);
  }
}
